import {
  faBookOpen,
  faChartLine,
  faClockRotateLeft,
  faCode,
  faDatabase,
  faShieldHalved,
} from '@fortawesome/pro-light-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

export type KnowledgeBaseResourceType = 'video' | 'doc';

export interface KnowledgeBaseResource {
  title: string;
  description: string;
  url: string;
  type: KnowledgeBaseResourceType;
  icon: IconDefinition;
}

export interface KnowledgeBaseSection {
  title: string;
  subtitle: string;
  resources: KnowledgeBaseResource[];
}

// Content is intentionally data-only: edit the entries below to change what the
// Knowledge Base shows. No component changes are required for content updates.
export const KNOWLEDGE_BASE_SECTIONS: KnowledgeBaseSection[] = [
  {
    title: 'Product videos',
    subtitle: 'Guided walkthroughs of each feature area.',
    resources: [
      {
        title: 'Market Data',
        description: 'Explore live and historical market data across venues.',
        url: 'https://docsend.com/view/78y6ba26nkztev5v',
        type: 'video',
        icon: faDatabase,
      },
      {
        title: 'Portfolio Performance',
        description: 'Track returns and attribution across your portfolio.',
        url: 'https://docsend.com/view/awgynrufprrgx3pz',
        type: 'video',
        icon: faChartLine,
      },
      {
        title: 'Risk Management',
        description: 'Monitor exposures and manage risk in real time.',
        url: 'https://docsend.com/view/mqw3ugn9z3ffqar3',
        type: 'video',
        icon: faShieldHalved,
      },
      {
        title: 'Backtester',
        description: 'Design and replay strategies against historical data.',
        url: 'https://docsend.com/view/prbpsz8mqccsmsf6',
        type: 'video',
        icon: faClockRotateLeft,
      },
    ],
  },
  {
    title: 'Documentation',
    subtitle: 'Reference material for the platform and the API.',
    resources: [
      {
        title: 'Feature documentation',
        description: 'Guides and reference for every part of the platform.',
        url: 'https://docs.immersive-finance.com',
        type: 'doc',
        icon: faBookOpen,
      },
      {
        title: 'API documentation',
        description: 'Integrate with the WebSocket API and endpoints.',
        url: 'https://immersive-finance.github.io/ws-api-docs/docs/intro',
        type: 'doc',
        icon: faCode,
      },
    ],
  },
];
